// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fa0708ef","239":"b20b7111","453":"dc73245c","622":"01055b51"}[chunkId] + ".chunk.js";
};